import { useState, useEffect } from 'react';

export function useTypewriter(text: string, speed: number = 200, pause: number = 2000, delay: number = 0) {
  const [display, setDisplay] = useState('');
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    let cancelled = false;
    let timeoutId: ReturnType<typeof setTimeout>;

    const type = async () => {
      // Initial delay
      if (delay > 0) {
        await new Promise((r) => { timeoutId = setTimeout(r, delay); });
        if (cancelled) return;
      }
      // Type forward
      for (let i = 0; i <= text.length; i++) {
        if (cancelled) return;
        setDisplay(text.slice(0, i));
        await new Promise((r) => { timeoutId = setTimeout(r, speed); });
      }
      // Pause at end
      if (cancelled) return;
      await new Promise((r) => { timeoutId = setTimeout(r, pause); });
      // Clear and restart
      if (cancelled) return;
      setDisplay('');
      await new Promise((r) => { timeoutId = setTimeout(r, speed); });
      if (!cancelled) type();
    };

    type();

    // Cursor blink
    const cursorInterval = setInterval(() => {
      setShowCursor((s) => !s);
    }, 530);

    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
      clearInterval(cursorInterval);
    };
  }, [text, speed, pause]);

  return { display, showCursor };
}
